import { AxiosHeaders, type InternalAxiosRequestConfig } from 'axios'

export const requestSuccess = (request: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const username = import.meta.env.VITE_DM_APPLICATION_CONFIG_BASIC_AUTH_USERNAME
  const password = import.meta.env.VITE_DM_APPLICATION_CONFIG_BASIC_AUTH_PASSWORD

  if (!request.headers) {
    request.headers = new AxiosHeaders()
  }

  request.headers.Authorization = `Basic ${btoa(`${username}:${password}`)}`

  return request
}
